import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import CompanyDepartmentDetails from '@/modules/settings/pages/CompanyDepartmentDetails';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/company-departments/$departmentId',
)({
  head: () => ({
    meta: [{ title: 'Detalhes do Departamento' }],
  }),
  parseParams: z.object({ departmentId: z.coerce.number() }).parse,
  component: function DepartmentDetailsRoute() {
    const { departmentId } = Route.useParams();

    return <CompanyDepartmentDetails id={departmentId} />;
  },
});
